// Get origin window location URL, with fallback
export const windowLocationOrigin = () => {
	if (window.location.origin) {
		return window.location.origin;
	} else {
		return (
			window.location.protocol +
			"//" +
			window.location.hostname +
			(window.location.port ? ":" + window.location.port : "")
		);
	}
};

export const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const checkExtToken = (exp: number) => {
	if (Date.now() >= exp * 1000) {
		return true;
	}
	return false
}